import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

export const supabase = createClient(supabaseUrl, supabaseKey);

export async function getPlayer(username) {
  const { data, error } = await supabase
    .from('players')
    .select('*')
    .ilike('username', username)
    .single();
  if (error) return null;
  return data;
}

export async function createPlayer(username, passkey, avatarId) {
  const { data, error } = await supabase
    .from('players')
    .insert([{ username, passkey, avatar_id: avatarId, best_score: 0, total_games: 0 }])
    .select()
    .single();
  if (error) return null;
  return data;
}

export async function updateScore(username, score, time) {
  const player = await getPlayer(username);
  if (!player) return null;
  const newBest  = Math.max(player.best_score || 0, score);
  const newGames = (player.total_games || 0) + 1;
  const now      = new Date().toLocaleString('en-IN', { timeZone: 'Asia/Kolkata' });
  const { data, error } = await supabase
    .from('players')
    .update({ best_score: newBest, total_games: newGames, last_played: now, time_survived: time })
    .ilike('username', username)
    .select()
    .single();
  if (error) return null;
  return data;
}

export async function getLeaderboard() {
  const { data, error } = await supabase
    .from('players')
    .select('username, best_score, total_games, avatar_id')
    .order('best_score', { ascending: false })
    .limit(20);
  if (error) return [];
  return data;
}